/* Poppy Scrubs custom JS — nav color swatch dots.
 * Vanilla rewrite of the 5.4.1 jQuery version (jQuery is not loaded in Broadcast 8.x). */
(function () {
  function addSwatchDots() {
    if (!window.theme || !window.theme.assets || !window.theme.assets.swatches) return;

    fetch(window.theme.assets.swatches)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var colorMap = {};
        (data.colors || []).forEach(function (entry) {
          Object.keys(entry).forEach(function (name) {
            colorMap[name.toLowerCase()] = entry[name];
          });
        });

        function makeDot(color) {
          var dot = document.createElement('span');
          dot.className = 'nav_color_swatch';
          dot.style.backgroundColor = color;
          return dot;
        }

        // Desktop dropdown: top-level items whose label contains "color"
        document.querySelectorAll('.menu__item.parent').forEach(function (item) {
          var top = item.querySelector('a');
          if (!top || top.textContent.toLowerCase().indexOf('color') === -1) return;
          item.querySelectorAll('.header__dropdown__inner a').forEach(function (link) {
            var textEl = link.querySelector('.navtext') || link.querySelector('span');
            if (!textEl) return;
            var color = colorMap[textEl.textContent.trim().toLowerCase()];
            if (!color) return;
            var existing = link.querySelector('.nav_color_swatch');
            if (existing) existing.remove();
            textEl.parentNode.insertBefore(makeDot(color), textEl);
          });
        });

        // Mobile drawer: sliderule panels whose title contains "color"
        document.querySelectorAll('.sliderule__panel > .sliderow .sliderow__title').forEach(function (title) {
          if (title.textContent.toLowerCase().indexOf('color') === -1) return;
          var panel = title.closest('.sliderule__panel');
          if (!panel) return;
          panel.querySelectorAll('.sliderow__links .sliderule__wrapper a, .sliderow__links a').forEach(function (link) {
            var color = colorMap[link.textContent.trim().toLowerCase()];
            if (!color) return;
            var existing = link.querySelector('.nav_color_swatch');
            if (existing) existing.remove();
            link.insertBefore(makeDot(color), link.firstChild);
          });
        });
      })
      .catch(function () { /* swatches.json missing — fail silent */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addSwatchDots);
  } else {
    addSwatchDots();
  }
  document.addEventListener('shopify:section:load', addSwatchDots);
})();
